import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationWrite, ParcelAppEntityParcelWrite } from '../../../../../../../openapi';
import { RoadControlsForm } from '../../../../common/components/road-controls-set/road-controls.form';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class NotificationGeneralRemarksRoadMarkingLocalisationForm extends RoadControlsForm {
  constructor() {
    super({
      geometry: new FormControl(null, environment.production ? Validators.required : []),
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      )
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return {
      ...value,
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      street: this.street.value
    };
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }
}
